import {gql} from '@apollo/client'

// Everything in Locked while it is open in this tab, and otherwise only a row for each item at its
// top, with a file's size. "status" is "unset", "sealed" or "open".
export const LOCKED = gql`
  query Locked {
    locked {
      status
      sealedItems {
        kind
        filesize
      }
      folders {
        id
        name
        parentId
        createdAt
        updatedAt
      }
      uploads {
        id
        filename
        filesize
        fileType
        status
        folderId
        createdAt
        updatedAt
        openedAt
        starredAt
        thumbnail {
          url
          durationMs
          pageCount
          excerpt
          peaks
          width
          height
        }
      }
      trash {
        folders {
          id
          name
          createdAt
          updatedAt
          deletedAt
        }
        uploads {
          id
          filename
          filesize
          fileType
          status
          folderId
          createdAt
          updatedAt
          deletedAt
        }
      }
    }
  }
`

// The pictures the Locked listing leaves out, opened by the API for the files asked after.
export const LOCKED_THUMBNAILS = gql`
  query LockedThumbnails($uploadIds: [ID!]!) {
    lockedThumbnails(uploadIds: $uploadIds) {
      uploadId
      url
    }
  }
`
